import { render, staticRenderFns } from "./orderDialog.vue?vue&type=template&id=dd38839c&scoped=true&"
import script from "./orderDialog.vue?vue&type=script&lang=js&"
export * from "./orderDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderDialog.vue?vue&type=style&index=0&id=dd38839c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd38839c",
  null
  
)

export default component.exports